import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { client } from '../api/client';
import { addHandlers, ThunkState } from '../app/utils/reducerUtils';
import { ConsultantSettings } from '../models/consultantSettings';

type ConsultantSettingsState = ThunkState & ConsultantSettings

export const activateConsultantLogin = createAsyncThunk('me/consultantLogin', (password: string) => {
  return client.post<string>('me/consultantLogin', password.replace(/\s+/g, ''), {
    handleUnauthorized: false
  });
});

const initialState: ConsultantSettingsState = {
  pending: 'idle',
  errors: [],
  consultantToken: false,
  modalOpen: false,
};

export const meSettingsSlice = createSlice({
  name: 'consultantSettings',
  initialState,
  reducers: {
    deactivateConsultantAccess: (state) => {
      state.consultantToken = false;
    },
    showModal: state => {
        state.modalOpen = true;
    },
    hideModal: state => {
        state.modalOpen = false;
    },
  },
  extraReducers: builder => {
    addHandlers({
      builder,
      thunk: activateConsultantLogin,
      onSuccess(state, action) {
        state.consultantToken = action.payload;
        state.modalOpen = false;
      },
    });
  },
});

export const {
  deactivateConsultantAccess,
  showModal,
  hideModal
} = meSettingsSlice.actions;

export default meSettingsSlice.reducer;
